import { TextField } from "@mui/material";
import React from "react";

const index = (props: { register: any, handleSubmit: any, errors: any, setFormValue: any, formValue: any, handleNext: any }) => {

  const onSubmit = (data: any) => {
    props.setFormValue({
      ...props.formValue,
      name: data.name,
      minPrice: data.minPrice,
      maxPrice: data.maxPrice,
    });

    props.handleNext();
  };  

  return <form id="page1" onSubmit={props.handleSubmit(onSubmit)}>
    <div className="grid grid-cols-3 gap-3">
      <div>
        <TextField size="small" fullWidth name="name" label="Name" {...props.register('name')} error={props.errors?.name ? true : false} />
        <p className="text-red-700 text-sm">{props.errors?.name?.message}</p>
      </div>
      <div>
        <TextField size="small" fullWidth name="minPrice" type="number" label="Min Price" {...props.register('minPrice')} error={props.errors?.minPrice ? true : false} />
        <p className="text-red-700 text-sm">{props.errors?.minPrice?.message}</p>
      </div>
      <div>
        <TextField size="small" fullWidth name="maxPrice" type="number" label="Max Price" {...props.register('maxPrice')} error={props.errors?.maxPrice ? true : false} />
        <p className="text-red-700 text-sm">{props.errors?.maxPrice?.message}</p>
      </div>
    </div>
  </form>;
};

export default index;
